export const removeTrailingSlash = (url?: string): string => {
    if (!url) return '';
    return url.endsWith('/') ? url.slice(0, -1) : url;
};

export const removeTrailingSlashOptional = (url?: string): string | undefined => {
    if (!url) return url;
    return url.endsWith('/') ? url.slice(0, -1) : url;
};
